<template>
  <div class="language-selector" v-if="show">
    <label class="language-selector__label">
      {{resource('language')}}
    </label>
    <select v-model="selectedLanguage" @change="setLanguage()" class="language-selector__value">
      <option v-for="lang in languages" :key="lang" :value="lang">{{resource(lang)}}</option>
    </select>
  </div>
</template>
<style lang="scss">
.language-selector{
  display: flex;
  padding: $content;
  align-items: center;
  &__label{
    margin-right: $content;
  }
  &__value{
    height: 30px;
    width: 150px;
  }
}
</style>
<script>
export default {
	name: 'languageSelector',
	created(){
		if(localStorage.language){
			this.$store.commit('selectLanguage', localStorage.language)
		}
	},
	data() {
		return {
			selectedLanguage: this.$store.getters.language,
			languages: ['nl', 'fr'],
			res:{
				nl:{
					language: 'Taal:',
					nl: 'Nederlands',
					fr: 'Frans'
				},
				fr:{
					language: 'Langue:',
					nl: 'Néerlandais',
					fr: 'Français'
				}
			}
		}
	},
	computed: {
		activeLanguage(){
			return this.$store.getters.language
		},
		site(){
			return this.$store.getters.userFilters.sites
		},
		show(){
			if(this.site.includes('feederone-eu-nl')){
				this.setLanguage('nl')
				return false
			}else{
				return true
			}
		}
	},
	watch:{
		activeLanguage(newVal){
			this.selectedLanguage = newVal
		},
	},
	methods: {
		resource(item){
			var lang = this.$store.getters.language
			return this.res[lang][item]
		},
		setLanguage(){
			this.$store.commit('selectLanguage', this.selectedLanguage)
		}
	},
}
</script>
